import React from "react";
import { API_URL } from "../config";
import axios from "axios";
import { showToast } from "../components/toast";

const BulkEditOrderPopup = ({
  isOpen,
  onClose,
  selectedOrders,
  fetchOrders,
}) => {
  const token = localStorage.getItem("authToken");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedOrders.length === 0) {
      showToast.warning("Please select at least one order to edit");
      return;
    }

    // Convert to number to match backend requirement
    const orderApproval = Number(e.target.orderapproval.value);

    try {
      const response = await axios.post(
        `${API_URL}orders/save-bulk-edit-order`,
        {
          order_approval: orderApproval, // now a number
          orderids: selectedOrders,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        showToast.success(
          response.data.message || "Orders updated successfully"
        );
        onClose();
        fetchOrders();
      } else {
        showToast.error(response.data.message || "Failed to update orders");
      }
    } catch (error) {
      console.error("Error updating orders:", error);
      showToast.error("An error occurred while updating orders");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title" style={{ fontWeight: "bold" }}>
              Edit Order
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
              style={{
                fontSize: "1.5rem",
                color: "black",
                background: "none",
                border: "none",
                lineHeight: "1",
              }}
            >
              &times;
            </button>
          </div>

          <div className="modal-body">
            <form
              name="popupPaid"
              id="placeEditOrderForm"
              onSubmit={handleSubmit}
              className="stdform"
            >
              <div className="panel-body">
                <div className="row">
                  <table
                    className="table table-condensed table-hover bg-white usertable"
                    width="100%"
                  >
                    <tbody>
                      <tr className="subscriber-block">
                        <td>
                          Order Approval <span style={{ color: "red" }}>*</span>
                        </td>
                        <td>
                          <select
                            name="orderapproval"
                            id="orderapproval"
                            className="form-control"
                            required
                          >
                            <option value="">Select</option>
                            <option value="0">Pending</option>
                            <option value="1">Approved</option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="col-md-12" style={{ textAlign: "right" }}>
                    <button
                      type="submit"
                      name="submit"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      name="cancel"
                      className="btn btn-default ms-2"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkEditOrderPopup;
